import PublicIcon from "@material-ui/icons/Public";
import { CountriesList } from "./list";
import { CountryCreate } from "./create";
import { CountryEdit } from "./edit";

export const CountryIcon = PublicIcon;

export { CountriesList, CountryCreate, CountryEdit };
